// source: xcommon/log.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var xcommon_common_pb = require('../xcommon/common_pb.js');
goog.object.extend(proto, xcommon_common_pb);
var xcommon_enum_pb = require('../xcommon/enum_pb.js');
goog.object.extend(proto, xcommon_enum_pb);
goog.exportSymbol('proto.xcommon.ListOpLogParamsReq', null, global);
goog.exportSymbol('proto.xcommon.ListOpLogParamsResp', null, global);
goog.exportSymbol('proto.xcommon.ListOpLogReq', null, global);
goog.exportSymbol('proto.xcommon.ListOpLogResp', null, global);
goog.exportSymbol('proto.xcommon.ListThirdpartyLogParamsReq', null, global);
goog.exportSymbol('proto.xcommon.ListThirdpartyLogParamsResp', null, global);
goog.exportSymbol('proto.xcommon.ListThirdpartyLogReq', null, global);
goog.exportSymbol('proto.xcommon.ListThirdpartyLogResp', null, global);
goog.exportSymbol('proto.xcommon.OpLogger', null, global);
goog.exportSymbol('proto.xcommon.ThirdParty', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListOpLogParamsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ListOpLogParamsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListOpLogParamsReq.displayName = 'proto.xcommon.ListOpLogParamsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListOpLogParamsResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ListOpLogParamsResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListOpLogParamsResp.displayName = 'proto.xcommon.ListOpLogParamsResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListOpLogReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ListOpLogReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListOpLogReq.displayName = 'proto.xcommon.ListOpLogReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListOpLogResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ListOpLogResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ListOpLogResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListOpLogResp.displayName = 'proto.xcommon.ListOpLogResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.OpLogger = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.OpLogger, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.OpLogger.displayName = 'proto.xcommon.OpLogger';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListThirdpartyLogParamsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ListThirdpartyLogParamsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListThirdpartyLogParamsReq.displayName = 'proto.xcommon.ListThirdpartyLogParamsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListThirdpartyLogParamsResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ListThirdpartyLogParamsResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListThirdpartyLogParamsResp.displayName = 'proto.xcommon.ListThirdpartyLogParamsResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListThirdpartyLogReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ListThirdpartyLogReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListThirdpartyLogReq.displayName = 'proto.xcommon.ListThirdpartyLogReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ListThirdpartyLogResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.ListThirdpartyLogResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.ListThirdpartyLogResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ListThirdpartyLogResp.displayName = 'proto.xcommon.ListThirdpartyLogResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ThirdParty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ThirdParty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ThirdParty.displayName = 'proto.xcommon.ThirdParty';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListOpLogParamsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListOpLogParamsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListOpLogParamsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListOpLogParamsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListOpLogParamsReq}
 */
proto.xcommon.ListOpLogParamsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListOpLogParamsReq;
  return proto.xcommon.ListOpLogParamsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListOpLogParamsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListOpLogParamsReq}
 */
proto.xcommon.ListOpLogParamsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListOpLogParamsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListOpLogParamsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListOpLogParamsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListOpLogParamsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ListOpLogParamsReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.ListOpLogParamsReq} returns this
*/
proto.xcommon.ListOpLogParamsReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.ListOpLogParamsReq} returns this
 */
proto.xcommon.ListOpLogParamsReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListOpLogParamsReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListOpLogParamsResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListOpLogParamsResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListOpLogParamsResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListOpLogParamsResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    params: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListOpLogParamsResp}
 */
proto.xcommon.ListOpLogParamsResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListOpLogParamsResp;
  return proto.xcommon.ListOpLogParamsResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListOpLogParamsResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListOpLogParamsResp}
 */
proto.xcommon.ListOpLogParamsResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setParams(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListOpLogParamsResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListOpLogParamsResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListOpLogParamsResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListOpLogParamsResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getParams();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ListOpLogParamsResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.ListOpLogParamsResp} returns this
*/
proto.xcommon.ListOpLogParamsResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.ListOpLogParamsResp} returns this
 */
proto.xcommon.ListOpLogParamsResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListOpLogParamsResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string Params = 2;
 * @return {string}
 */
proto.xcommon.ListOpLogParamsResp.prototype.getParams = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ListOpLogParamsResp} returns this
 */
proto.xcommon.ListOpLogParamsResp.prototype.setParams = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListOpLogReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListOpLogReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListOpLogReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListOpLogReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 3, ""),
    opuid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    relatedid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    opcode: jspb.Message.getFieldWithDefault(msg, 6, 0),
    optable: jspb.Message.getFieldWithDefault(msg, 7, ""),
    month: jspb.Message.getFieldWithDefault(msg, 8, ""),
    begindate: jspb.Message.getFieldWithDefault(msg, 9, ""),
    enddate: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListOpLogReq}
 */
proto.xcommon.ListOpLogReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListOpLogReq;
  return proto.xcommon.ListOpLogReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListOpLogReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListOpLogReq}
 */
proto.xcommon.ListOpLogReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpuid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRelatedid(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpcode(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setOptable(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setMonth(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setBegindate(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnddate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListOpLogReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListOpLogReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListOpLogReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListOpLogReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOpuid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getRelatedid();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getOpcode();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getOptable();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getMonth();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getBegindate();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getEnddate();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ListOpLogReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.ListOpLogReq} returns this
*/
proto.xcommon.ListOpLogReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.ListOpLogReq} returns this
 */
proto.xcommon.ListOpLogReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListOpLogReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.ListOpLogReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/**
 * @param {?proto.xcommon.PageIn|undefined} value
 * @return {!proto.xcommon.ListOpLogReq} returns this
*/
proto.xcommon.ListOpLogReq.prototype.setPagein = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.ListOpLogReq} returns this
 */
proto.xcommon.ListOpLogReq.prototype.clearPagein = function() {
  return this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListOpLogReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string Id = 3;
 * @return {string}
 */
proto.xcommon.ListOpLogReq.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ListOpLogReq} returns this
 */
proto.xcommon.ListOpLogReq.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 OpUid = 4;
 * @return {number}
 */
proto.xcommon.ListOpLogReq.prototype.getOpuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ListOpLogReq} returns this
 */
proto.xcommon.ListOpLogReq.prototype.setOpuid = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 RelatedId = 5;
 * @return {number}
 */
proto.xcommon.ListOpLogReq.prototype.getRelatedid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ListOpLogReq} returns this
 */
proto.xcommon.ListOpLogReq.prototype.setRelatedid = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 OpCode = 6;
 * @return {number}
 */
proto.xcommon.ListOpLogReq.prototype.getOpcode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ListOpLogReq} returns this
 */
proto.xcommon.ListOpLogReq.prototype.setOpcode = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string OpTable = 7;
 * @return {string}
 */
proto.xcommon.ListOpLogReq.prototype.getOptable = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ListOpLogReq} returns this
 */
proto.xcommon.ListOpLogReq.prototype.setOptable = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string Month = 8;
 * @return {string}
 */
proto.xcommon.ListOpLogReq.prototype.getMonth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ListOpLogReq} returns this
 */
proto.xcommon.ListOpLogReq.prototype.setMonth = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string BeginDate = 9;
 * @return {string}
 */
proto.xcommon.ListOpLogReq.prototype.getBegindate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ListOpLogReq} returns this
 */
proto.xcommon.ListOpLogReq.prototype.setBegindate = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string EndDate = 10;
 * @return {string}
 */
proto.xcommon.ListOpLogReq.prototype.getEnddate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ListOpLogReq} returns this
 */
proto.xcommon.ListOpLogReq.prototype.setEnddate = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ListOpLogResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListOpLogResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListOpLogResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListOpLogResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListOpLogResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    oploggersList: jspb.Message.toObjectList(msg.getOploggersList(),
    proto.xcommon.OpLogger.toObject, includeInstance),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListOpLogResp}
 */
proto.xcommon.ListOpLogResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListOpLogResp;
  return proto.xcommon.ListOpLogResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListOpLogResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListOpLogResp}
 */
proto.xcommon.ListOpLogResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.OpLogger;
      reader.readMessage(value,proto.xcommon.OpLogger.deserializeBinaryFromReader);
      msg.addOploggers(value);
      break;
    case 3:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListOpLogResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListOpLogResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListOpLogResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListOpLogResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getOploggersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.OpLogger.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ListOpLogResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.ListOpLogResp} returns this
*/
proto.xcommon.ListOpLogResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.ListOpLogResp} returns this
 */
proto.xcommon.ListOpLogResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListOpLogResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated OpLogger OpLoggers = 2;
 * @return {!Array<!proto.xcommon.OpLogger>}
 */
proto.xcommon.ListOpLogResp.prototype.getOploggersList = function() {
  return /** @type{!Array<!proto.xcommon.OpLogger>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.OpLogger, 2));
};


/**
 * @param {!Array<!proto.xcommon.OpLogger>} value
 * @return {!proto.xcommon.ListOpLogResp} returns this
*/
proto.xcommon.ListOpLogResp.prototype.setOploggersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.OpLogger=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.OpLogger}
 */
proto.xcommon.ListOpLogResp.prototype.addOploggers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.OpLogger, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.ListOpLogResp} returns this
 */
proto.xcommon.ListOpLogResp.prototype.clearOploggersList = function() {
  return this.setOploggersList([]);
};


/**
 * optional PageOut PageOut = 3;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.ListOpLogResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 3));
};


/**
 * @param {?proto.xcommon.PageOut|undefined} value
 * @return {!proto.xcommon.ListOpLogResp} returns this
*/
proto.xcommon.ListOpLogResp.prototype.setPageout = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.ListOpLogResp} returns this
 */
proto.xcommon.ListOpLogResp.prototype.clearPageout = function() {
  return this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListOpLogResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.OpLogger.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.OpLogger.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.OpLogger} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OpLogger.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, ""),
    opuid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    relatedid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    opcode: jspb.Message.getFieldWithDefault(msg, 5, 0),
    optable: jspb.Message.getFieldWithDefault(msg, 6, ""),
    oplog: jspb.Message.getFieldWithDefault(msg, 7, ""),
    ctime: jspb.Message.getFieldWithDefault(msg, 9, 0),
    opcodename: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.OpLogger}
 */
proto.xcommon.OpLogger.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.OpLogger;
  return proto.xcommon.OpLogger.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.OpLogger} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.OpLogger}
 */
proto.xcommon.OpLogger.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpuid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRelatedid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpcode(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setOptable(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setOplog(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpcodename(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.OpLogger.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.OpLogger.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.OpLogger} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OpLogger.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOpuid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getRelatedid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getOpcode();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getOptable();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getOplog();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getOpcodename();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.OpLogger.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.OpLogger} returns this
*/
proto.xcommon.OpLogger.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.OpLogger} returns this
 */
proto.xcommon.OpLogger.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.OpLogger.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string Id = 2;
 * @return {string}
 */
proto.xcommon.OpLogger.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.OpLogger} returns this
 */
proto.xcommon.OpLogger.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 OpUid = 3;
 * @return {number}
 */
proto.xcommon.OpLogger.prototype.getOpuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OpLogger} returns this
 */
proto.xcommon.OpLogger.prototype.setOpuid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 RelatedId = 4;
 * @return {number}
 */
proto.xcommon.OpLogger.prototype.getRelatedid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OpLogger} returns this
 */
proto.xcommon.OpLogger.prototype.setRelatedid = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 OpCode = 5;
 * @return {number}
 */
proto.xcommon.OpLogger.prototype.getOpcode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OpLogger} returns this
 */
proto.xcommon.OpLogger.prototype.setOpcode = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string OpTable = 6;
 * @return {string}
 */
proto.xcommon.OpLogger.prototype.getOptable = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.OpLogger} returns this
 */
proto.xcommon.OpLogger.prototype.setOptable = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string OpLog = 7;
 * @return {string}
 */
proto.xcommon.OpLogger.prototype.getOplog = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.OpLogger} returns this
 */
proto.xcommon.OpLogger.prototype.setOplog = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 Ctime = 9;
 * @return {number}
 */
proto.xcommon.OpLogger.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.OpLogger} returns this
 */
proto.xcommon.OpLogger.prototype.setCtime = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string OpCodeName = 10;
 * @return {string}
 */
proto.xcommon.OpLogger.prototype.getOpcodename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.OpLogger} returns this
 */
proto.xcommon.OpLogger.prototype.setOpcodename = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListThirdpartyLogParamsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListThirdpartyLogParamsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListThirdpartyLogParamsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListThirdpartyLogParamsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListThirdpartyLogParamsReq}
 */
proto.xcommon.ListThirdpartyLogParamsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListThirdpartyLogParamsReq;
  return proto.xcommon.ListThirdpartyLogParamsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListThirdpartyLogParamsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListThirdpartyLogParamsReq}
 */
proto.xcommon.ListThirdpartyLogParamsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListThirdpartyLogParamsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListThirdpartyLogParamsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListThirdpartyLogParamsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListThirdpartyLogParamsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ListThirdpartyLogParamsReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.ListThirdpartyLogParamsReq} returns this
*/
proto.xcommon.ListThirdpartyLogParamsReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.ListThirdpartyLogParamsReq} returns this
 */
proto.xcommon.ListThirdpartyLogParamsReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListThirdpartyLogParamsReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListThirdpartyLogParamsResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListThirdpartyLogParamsResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListThirdpartyLogParamsResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListThirdpartyLogParamsResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    params: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListThirdpartyLogParamsResp}
 */
proto.xcommon.ListThirdpartyLogParamsResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListThirdpartyLogParamsResp;
  return proto.xcommon.ListThirdpartyLogParamsResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListThirdpartyLogParamsResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListThirdpartyLogParamsResp}
 */
proto.xcommon.ListThirdpartyLogParamsResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setParams(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListThirdpartyLogParamsResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListThirdpartyLogParamsResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListThirdpartyLogParamsResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListThirdpartyLogParamsResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getParams();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ListThirdpartyLogParamsResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.ListThirdpartyLogParamsResp} returns this
*/
proto.xcommon.ListThirdpartyLogParamsResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.ListThirdpartyLogParamsResp} returns this
 */
proto.xcommon.ListThirdpartyLogParamsResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListThirdpartyLogParamsResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string Params = 2;
 * @return {string}
 */
proto.xcommon.ListThirdpartyLogParamsResp.prototype.getParams = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ListThirdpartyLogParamsResp} returns this
 */
proto.xcommon.ListThirdpartyLogParamsResp.prototype.setParams = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListThirdpartyLogReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListThirdpartyLogReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListThirdpartyLogReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListThirdpartyLogReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 3, ""),
    thirdparty: jspb.Message.getFieldWithDefault(msg, 4, ""),
    relatedtid: jspb.Message.getFieldWithDefault(msg, 5, ""),
    relateduid: jspb.Message.getFieldWithDefault(msg, 6, ""),
    apitype: jspb.Message.getFieldWithDefault(msg, 7, ""),
    api: jspb.Message.getFieldWithDefault(msg, 8, ""),
    apitag: jspb.Message.getFieldWithDefault(msg, 9, ""),
    request: jspb.Message.getFieldWithDefault(msg, 10, ""),
    response: jspb.Message.getFieldWithDefault(msg, 11, ""),
    httpresponsecode: jspb.Message.getFieldWithDefault(msg, 12, 0),
    consumingstart: jspb.Message.getFieldWithDefault(msg, 13, 0),
    consumingend: jspb.Message.getFieldWithDefault(msg, 14, 0),
    requestappkey: jspb.Message.getFieldWithDefault(msg, 15, ""),
    fromappkey: jspb.Message.getFieldWithDefault(msg, 16, ""),
    isfailure: jspb.Message.getFieldWithDefault(msg, 17, 0),
    isbilling: jspb.Message.getFieldWithDefault(msg, 18, 0),
    begindate: jspb.Message.getFieldWithDefault(msg, 19, ""),
    enddate: jspb.Message.getFieldWithDefault(msg, 20, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListThirdpartyLogReq}
 */
proto.xcommon.ListThirdpartyLogReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListThirdpartyLogReq;
  return proto.xcommon.ListThirdpartyLogReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListThirdpartyLogReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListThirdpartyLogReq}
 */
proto.xcommon.ListThirdpartyLogReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setThirdparty(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRelatedtid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setRelateduid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setApitype(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setApi(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setApitag(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequest(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setResponse(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHttpresponsecode(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setConsumingstart(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setConsumingend(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestappkey(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setFromappkey(value);
      break;
    case 17:
      var value = /** @type {!proto.xcommon.YNType} */ (reader.readEnum());
      msg.setIsfailure(value);
      break;
    case 18:
      var value = /** @type {!proto.xcommon.YNType} */ (reader.readEnum());
      msg.setIsbilling(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setBegindate(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnddate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListThirdpartyLogReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListThirdpartyLogReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListThirdpartyLogReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListThirdpartyLogReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getThirdparty();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRelatedtid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRelateduid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getApitype();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getApi();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getApitag();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getRequest();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getResponse();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getHttpresponsecode();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getConsumingstart();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getConsumingend();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getRequestappkey();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getFromappkey();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getIsfailure();
  if (f !== 0.0) {
    writer.writeEnum(
      17,
      f
    );
  }
  f = message.getIsbilling();
  if (f !== 0.0) {
    writer.writeEnum(
      18,
      f
    );
  }
  f = message.getBegindate();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getEnddate();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ListThirdpartyLogReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.ListThirdpartyLogReq} returns this
*/
proto.xcommon.ListThirdpartyLogReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.ListThirdpartyLogReq} returns this
 */
proto.xcommon.ListThirdpartyLogReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListThirdpartyLogReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.xcommon.ListThirdpartyLogReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/**
 * @param {?proto.xcommon.PageIn|undefined} value
 * @return {!proto.xcommon.ListThirdpartyLogReq} returns this
*/
proto.xcommon.ListThirdpartyLogReq.prototype.setPagein = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.ListThirdpartyLogReq} returns this
 */
proto.xcommon.ListThirdpartyLogReq.prototype.clearPagein = function() {
  return this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListThirdpartyLogReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string Id = 3;
 * @return {string}
 */
proto.xcommon.ListThirdpartyLogReq.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ListThirdpartyLogReq} returns this
 */
proto.xcommon.ListThirdpartyLogReq.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Thirdparty = 4;
 * @return {string}
 */
proto.xcommon.ListThirdpartyLogReq.prototype.getThirdparty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ListThirdpartyLogReq} returns this
 */
proto.xcommon.ListThirdpartyLogReq.prototype.setThirdparty = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string RelatedTid = 5;
 * @return {string}
 */
proto.xcommon.ListThirdpartyLogReq.prototype.getRelatedtid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ListThirdpartyLogReq} returns this
 */
proto.xcommon.ListThirdpartyLogReq.prototype.setRelatedtid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string RelatedUid = 6;
 * @return {string}
 */
proto.xcommon.ListThirdpartyLogReq.prototype.getRelateduid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ListThirdpartyLogReq} returns this
 */
proto.xcommon.ListThirdpartyLogReq.prototype.setRelateduid = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string ApiType = 7;
 * @return {string}
 */
proto.xcommon.ListThirdpartyLogReq.prototype.getApitype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ListThirdpartyLogReq} returns this
 */
proto.xcommon.ListThirdpartyLogReq.prototype.setApitype = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string Api = 8;
 * @return {string}
 */
proto.xcommon.ListThirdpartyLogReq.prototype.getApi = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ListThirdpartyLogReq} returns this
 */
proto.xcommon.ListThirdpartyLogReq.prototype.setApi = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string ApiTag = 9;
 * @return {string}
 */
proto.xcommon.ListThirdpartyLogReq.prototype.getApitag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ListThirdpartyLogReq} returns this
 */
proto.xcommon.ListThirdpartyLogReq.prototype.setApitag = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string Request = 10;
 * @return {string}
 */
proto.xcommon.ListThirdpartyLogReq.prototype.getRequest = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ListThirdpartyLogReq} returns this
 */
proto.xcommon.ListThirdpartyLogReq.prototype.setRequest = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string Response = 11;
 * @return {string}
 */
proto.xcommon.ListThirdpartyLogReq.prototype.getResponse = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ListThirdpartyLogReq} returns this
 */
proto.xcommon.ListThirdpartyLogReq.prototype.setResponse = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional int64 HttpResponseCode = 12;
 * @return {number}
 */
proto.xcommon.ListThirdpartyLogReq.prototype.getHttpresponsecode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ListThirdpartyLogReq} returns this
 */
proto.xcommon.ListThirdpartyLogReq.prototype.setHttpresponsecode = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 ConsumingStart = 13;
 * @return {number}
 */
proto.xcommon.ListThirdpartyLogReq.prototype.getConsumingstart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ListThirdpartyLogReq} returns this
 */
proto.xcommon.ListThirdpartyLogReq.prototype.setConsumingstart = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int64 ConsumingEnd = 14;
 * @return {number}
 */
proto.xcommon.ListThirdpartyLogReq.prototype.getConsumingend = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ListThirdpartyLogReq} returns this
 */
proto.xcommon.ListThirdpartyLogReq.prototype.setConsumingend = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional string RequestAppKey = 15;
 * @return {string}
 */
proto.xcommon.ListThirdpartyLogReq.prototype.getRequestappkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ListThirdpartyLogReq} returns this
 */
proto.xcommon.ListThirdpartyLogReq.prototype.setRequestappkey = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string FromAppKey = 16;
 * @return {string}
 */
proto.xcommon.ListThirdpartyLogReq.prototype.getFromappkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ListThirdpartyLogReq} returns this
 */
proto.xcommon.ListThirdpartyLogReq.prototype.setFromappkey = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional YNType IsFailure = 17;
 * @return {!proto.xcommon.YNType}
 */
proto.xcommon.ListThirdpartyLogReq.prototype.getIsfailure = function() {
  return /** @type {!proto.xcommon.YNType} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {!proto.xcommon.YNType} value
 * @return {!proto.xcommon.ListThirdpartyLogReq} returns this
 */
proto.xcommon.ListThirdpartyLogReq.prototype.setIsfailure = function(value) {
  return jspb.Message.setProto3EnumField(this, 17, value);
};


/**
 * optional YNType IsBilling = 18;
 * @return {!proto.xcommon.YNType}
 */
proto.xcommon.ListThirdpartyLogReq.prototype.getIsbilling = function() {
  return /** @type {!proto.xcommon.YNType} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {!proto.xcommon.YNType} value
 * @return {!proto.xcommon.ListThirdpartyLogReq} returns this
 */
proto.xcommon.ListThirdpartyLogReq.prototype.setIsbilling = function(value) {
  return jspb.Message.setProto3EnumField(this, 18, value);
};


/**
 * optional string BeginDate = 19;
 * @return {string}
 */
proto.xcommon.ListThirdpartyLogReq.prototype.getBegindate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ListThirdpartyLogReq} returns this
 */
proto.xcommon.ListThirdpartyLogReq.prototype.setBegindate = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string EndDate = 20;
 * @return {string}
 */
proto.xcommon.ListThirdpartyLogReq.prototype.getEnddate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ListThirdpartyLogReq} returns this
 */
proto.xcommon.ListThirdpartyLogReq.prototype.setEnddate = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.ListThirdpartyLogResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ListThirdpartyLogResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ListThirdpartyLogResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ListThirdpartyLogResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListThirdpartyLogResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    thirdpartysList: jspb.Message.toObjectList(msg.getThirdpartysList(),
    proto.xcommon.ThirdParty.toObject, includeInstance),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ListThirdpartyLogResp}
 */
proto.xcommon.ListThirdpartyLogResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ListThirdpartyLogResp;
  return proto.xcommon.ListThirdpartyLogResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ListThirdpartyLogResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ListThirdpartyLogResp}
 */
proto.xcommon.ListThirdpartyLogResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.ThirdParty;
      reader.readMessage(value,proto.xcommon.ThirdParty.deserializeBinaryFromReader);
      msg.addThirdpartys(value);
      break;
    case 3:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ListThirdpartyLogResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ListThirdpartyLogResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ListThirdpartyLogResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ListThirdpartyLogResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getThirdpartysList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.ThirdParty.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.ListThirdpartyLogResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.ListThirdpartyLogResp} returns this
*/
proto.xcommon.ListThirdpartyLogResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.ListThirdpartyLogResp} returns this
 */
proto.xcommon.ListThirdpartyLogResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListThirdpartyLogResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated ThirdParty ThirdPartys = 2;
 * @return {!Array<!proto.xcommon.ThirdParty>}
 */
proto.xcommon.ListThirdpartyLogResp.prototype.getThirdpartysList = function() {
  return /** @type{!Array<!proto.xcommon.ThirdParty>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.ThirdParty, 2));
};


/**
 * @param {!Array<!proto.xcommon.ThirdParty>} value
 * @return {!proto.xcommon.ListThirdpartyLogResp} returns this
*/
proto.xcommon.ListThirdpartyLogResp.prototype.setThirdpartysList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.ThirdParty=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.ThirdParty}
 */
proto.xcommon.ListThirdpartyLogResp.prototype.addThirdpartys = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.ThirdParty, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.ListThirdpartyLogResp} returns this
 */
proto.xcommon.ListThirdpartyLogResp.prototype.clearThirdpartysList = function() {
  return this.setThirdpartysList([]);
};


/**
 * optional PageOut PageOut = 3;
 * @return {?proto.xcommon.PageOut}
 */
proto.xcommon.ListThirdpartyLogResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 3));
};


/**
 * @param {?proto.xcommon.PageOut|undefined} value
 * @return {!proto.xcommon.ListThirdpartyLogResp} returns this
*/
proto.xcommon.ListThirdpartyLogResp.prototype.setPageout = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.ListThirdpartyLogResp} returns this
 */
proto.xcommon.ListThirdpartyLogResp.prototype.clearPageout = function() {
  return this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ListThirdpartyLogResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ThirdParty.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ThirdParty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ThirdParty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ThirdParty.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, ""),
    trackid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    apitype: jspb.Message.getFieldWithDefault(msg, 4, ""),
    thirdparty: jspb.Message.getFieldWithDefault(msg, 5, ""),
    relatedtid: jspb.Message.getFieldWithDefault(msg, 6, ""),
    relateduid: jspb.Message.getFieldWithDefault(msg, 7, ""),
    api: jspb.Message.getFieldWithDefault(msg, 8, ""),
    apitag: jspb.Message.getFieldWithDefault(msg, 9, ""),
    header: jspb.Message.getFieldWithDefault(msg, 10, ""),
    request: jspb.Message.getFieldWithDefault(msg, 11, ""),
    response: jspb.Message.getFieldWithDefault(msg, 12, ""),
    httpresponsecode: jspb.Message.getFieldWithDefault(msg, 13, 0),
    consuming: jspb.Message.getFieldWithDefault(msg, 14, ""),
    requestappkey: jspb.Message.getFieldWithDefault(msg, 15, ""),
    fromappkey: jspb.Message.getFieldWithDefault(msg, 16, ""),
    isfailure: jspb.Message.getFieldWithDefault(msg, 17, 0),
    isbilling: jspb.Message.getFieldWithDefault(msg, 18, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 19, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ThirdParty}
 */
proto.xcommon.ThirdParty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ThirdParty;
  return proto.xcommon.ThirdParty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ThirdParty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ThirdParty}
 */
proto.xcommon.ThirdParty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTrackid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setApitype(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setThirdparty(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setRelatedtid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setRelateduid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setApi(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setApitag(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setHeader(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequest(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setResponse(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHttpresponsecode(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setConsuming(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestappkey(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setFromappkey(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsfailure(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsbilling(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ThirdParty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ThirdParty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ThirdParty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ThirdParty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTrackid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getApitype();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getThirdparty();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRelatedtid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getRelateduid();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getApi();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getApitag();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getHeader();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getRequest();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getResponse();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getHttpresponsecode();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getConsuming();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getRequestappkey();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getFromappkey();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getIsfailure();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
  f = message.getIsbilling();
  if (f !== 0) {
    writer.writeInt32(
      18,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      19,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.ThirdParty.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.ThirdParty} returns this
*/
proto.xcommon.ThirdParty.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.ThirdParty} returns this
 */
proto.xcommon.ThirdParty.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ThirdParty.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string Id = 2;
 * @return {string}
 */
proto.xcommon.ThirdParty.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ThirdParty} returns this
 */
proto.xcommon.ThirdParty.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string TrackId = 3;
 * @return {string}
 */
proto.xcommon.ThirdParty.prototype.getTrackid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ThirdParty} returns this
 */
proto.xcommon.ThirdParty.prototype.setTrackid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string ApiType = 4;
 * @return {string}
 */
proto.xcommon.ThirdParty.prototype.getApitype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ThirdParty} returns this
 */
proto.xcommon.ThirdParty.prototype.setApitype = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Thirdparty = 5;
 * @return {string}
 */
proto.xcommon.ThirdParty.prototype.getThirdparty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ThirdParty} returns this
 */
proto.xcommon.ThirdParty.prototype.setThirdparty = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string RelatedTId = 6;
 * @return {string}
 */
proto.xcommon.ThirdParty.prototype.getRelatedtid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ThirdParty} returns this
 */
proto.xcommon.ThirdParty.prototype.setRelatedtid = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string RelatedUId = 7;
 * @return {string}
 */
proto.xcommon.ThirdParty.prototype.getRelateduid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ThirdParty} returns this
 */
proto.xcommon.ThirdParty.prototype.setRelateduid = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string Api = 8;
 * @return {string}
 */
proto.xcommon.ThirdParty.prototype.getApi = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ThirdParty} returns this
 */
proto.xcommon.ThirdParty.prototype.setApi = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string ApiTag = 9;
 * @return {string}
 */
proto.xcommon.ThirdParty.prototype.getApitag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ThirdParty} returns this
 */
proto.xcommon.ThirdParty.prototype.setApitag = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string Header = 10;
 * @return {string}
 */
proto.xcommon.ThirdParty.prototype.getHeader = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ThirdParty} returns this
 */
proto.xcommon.ThirdParty.prototype.setHeader = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string Request = 11;
 * @return {string}
 */
proto.xcommon.ThirdParty.prototype.getRequest = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ThirdParty} returns this
 */
proto.xcommon.ThirdParty.prototype.setRequest = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string Response = 12;
 * @return {string}
 */
proto.xcommon.ThirdParty.prototype.getResponse = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ThirdParty} returns this
 */
proto.xcommon.ThirdParty.prototype.setResponse = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional int32 HttpResponseCode = 13;
 * @return {number}
 */
proto.xcommon.ThirdParty.prototype.getHttpresponsecode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ThirdParty} returns this
 */
proto.xcommon.ThirdParty.prototype.setHttpresponsecode = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional string Consuming = 14;
 * @return {string}
 */
proto.xcommon.ThirdParty.prototype.getConsuming = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ThirdParty} returns this
 */
proto.xcommon.ThirdParty.prototype.setConsuming = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string RequestAppKey = 15;
 * @return {string}
 */
proto.xcommon.ThirdParty.prototype.getRequestappkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ThirdParty} returns this
 */
proto.xcommon.ThirdParty.prototype.setRequestappkey = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string FromAppKey = 16;
 * @return {string}
 */
proto.xcommon.ThirdParty.prototype.getFromappkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ThirdParty} returns this
 */
proto.xcommon.ThirdParty.prototype.setFromappkey = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional int32 IsFailure = 17;
 * @return {number}
 */
proto.xcommon.ThirdParty.prototype.getIsfailure = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ThirdParty} returns this
 */
proto.xcommon.ThirdParty.prototype.setIsfailure = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int32 IsBilling = 18;
 * @return {number}
 */
proto.xcommon.ThirdParty.prototype.getIsbilling = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ThirdParty} returns this
 */
proto.xcommon.ThirdParty.prototype.setIsbilling = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional int64 Ctime = 19;
 * @return {number}
 */
proto.xcommon.ThirdParty.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ThirdParty} returns this
 */
proto.xcommon.ThirdParty.prototype.setCtime = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


module.exports = proto.xcommon;
